import React from 'react';
import { FormField } from '../../components/FormField';
import { useAgents } from '../../../../../hooks/useAgents';
import { getPriceLabels } from './PricingLabels';
import { usePropertyFormContext } from '../../contexts/PropertyFormContext';
import { Ban } from 'lucide-react';
import { formatPrice } from '../../../../../utils/formatters';

export const PricingInfo: React.FC = () => {
  const { agents } = useAgents();
  const { formData, handleInputChange } = usePropertyFormContext();
  const isPromotion = formData.propertyType?.toLowerCase() === 'promotion';
  const isSale = formData.transactionType === 'sale';
  
  const priceLabels = getPriceLabels(formData.transactionType);

  // Gestionnaire pour les champs de prix (supprime les décimales)
  const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    // Supprimer tout sauf les chiffres
    const numericValue = value.replace(/[^\d]/g, '');
    
    handleInputChange({
      target: {
        name,
        value: numericValue,
        type: 'text'
      }
    } as React.ChangeEvent<HTMLInputElement>);
  };
  // Calculer le prix de vente sans décimales
  const calculateSalePrice = () => {
    const sellerPrice = parseFloat(formData.sellerPrice?.replace(/\s/g, '')) || 0;
    const commission = parseFloat(formData.agencyCommission?.replace(/\s/g, '')) || 0;
    return Math.floor(sellerPrice + commission).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };
  return (
    <div className="col-span-2 mt-8 border-t pt-8">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
        Informations financières
      </h3>

      <div className="grid grid-cols-3 gap-6">
        {isPromotion && (
          <FormField label="Prix">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="priceOnRequest"
                checked={formData.priceOnRequest || false}
                onChange={handleInputChange}
              />
              <span>Prix : Nous Consulter</span>
            </label>
          </FormField>
        )}

        {!formData.priceOnRequest && (
          <>
            <FormField label={priceLabels.sellerPrice}>
              <input
                type="text"
                name="sellerPrice"
                value={formatPrice(formData.sellerPrice)}
                onChange={handlePriceChange}
                className="w-full"
                placeholder="0"
              />
            </FormField>

            <FormField label={priceLabels.commission}>
              <input
                type="text"
                name="agencyCommission"
                value={formatPrice(formData.agencyCommission)}
                onChange={handlePriceChange}
                className="w-full"
                placeholder="0"
              />
            </FormField>

            <FormField label={priceLabels.finalPrice}>
              <div className="relative group">
                <input
                  type="text"
                  value={calculateSalePrice()}
                  readOnly
                  className="w-full bg-amber-50 border-amber-200 text-amber-800 font-semibold cursor-not-allowed dark:bg-amber-900/20 dark:border-amber-800 dark:text-amber-300"
                  title="Ce champ est calculé automatiquement et ne peut pas être modifié"
                />
                <div className="absolute right-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <Ban className="h-4 w-4 text-amber-600 dark:text-amber-400" />
                </div>
              </div>
            </FormField>
          </>
        )}

        <div className="col-span-3">
          <FormField label="Commercial">
            <select
              name="agent"
              value={formData.agent}
              onChange={handleInputChange}
              className="w-full"
            >
              <option value="">Sélectionner un commercial</option>
              {agents.map(agent => (
                <option key={agent.id} value={agent.id}>
                  {agent.name} - {agent.title}
                </option>
              ))}
            </select>
          </FormField>
        </div>
      </div>
    </div>
  );
};